import React, {CSSProperties} from 'react'
import {useEnvironment} from '../environment'
import {useAnalytics, useUserIdentifiedLink} from '../lib/analytics/analytics'
import {StyledDocsIcon} from './library/icon/icon'
import {Tooltip} from './library/tooltip/tooltip'

export const DocsLinkIcon = ({
  to,
  style,
  iconWidth,
  iconHeight
}: {
  to: string
  style?: CSSProperties
  // setting the size seems to be necessary when using inline vs block level
  iconWidth?: string
  iconHeight?: string
}) => {
  const {environment} = useEnvironment()
  const analytics = useAnalytics()
  const addSubQueryParam = useUserIdentifiedLink()

  return (
    <a
      href={addSubQueryParam(to)}
      rel="noreferrer"
      target="_blank"
      onClick={() => {
        if (environment) {
          analytics.track({
            event: 'Redirected to external URL',
            properties: {
              url: to,
              environment_id: environment.id,
              org_id: environment.organisationId,
              category: 'general'
            }
          })
        }
      }}
      style={style}
    >
      <Tooltip content="documentation" isLight={false} position="top-right">
        <StyledDocsIcon
          height={iconHeight ?? '1em'}
          width={iconWidth ?? '1em'}
          style={{
            position: 'relative',
            top: '.125em'
          }}
        />
      </Tooltip>
    </a>
  )
}
